// API route and payload names are kept compatible with the server.
import { EP_GET_ROOM, EP_HOST, EP_JOIN, EP_LEAVE } from '../constants/endPointConstants';
import api from './Api';
import { rememberRoomMembership, rememberRoomCredential } from './RoomSession';

const getRoomData = async (roomId, playerId, options = {}) => {
    const response = await api.get(`${EP_GET_ROOM}/${roomId}/${playerId}`, options);
    return response?.data;
};

const joinRoom = async (roomId, playerName, playerId, options = {}) => {
    const response = await api.post(`${EP_JOIN}/${encodeURIComponent(roomId)}/${encodeURIComponent(playerName)}/${playerId || ''}`, null, { params: options });
    rememberRoomMembership(roomId, response?.data?.membershipVersion);
    rememberRoomCredential(roomId, response?.data?.roomCredential);
    return response?.data;
}

const autoRejoinRoom = async (roomId, playerName) => {
    const response = await api.post(`/api/game/autorejoin/${encodeURIComponent(roomId)}/${encodeURIComponent(playerName)}`, null, { _roomId: roomId });
    rememberRoomMembership(roomId, response?.data?.membershipVersion);
    rememberRoomCredential(roomId, response?.data?.roomCredential);
    return response?.data;
};

const createNewRoom = async (playerName, deckCount, jokerPairs, options = {}) => {
    const response = await api.post(`${EP_HOST}`, {playerName, deckCount, jokerPairs, ...options});
    rememberRoomMembership(response?.data?.roomId, response?.data?.membershipVersion);
    rememberRoomCredential(response?.data?.roomId, response?.data?.roomCredential);
    return response?.data;
}

const leaveRoom = async (roomId, playerId) => {
    const response = await api.post(`${EP_LEAVE}/${roomId}/${playerId}`);
    return response?.data;
}

const playRandom = async (playerName, options = {}) => {
    const response = await api.post('/api/rooms/random', { playerName, ...options });
    rememberRoomMembership(response.data.roomId, response.data.membershipVersion);
    rememberRoomCredential(response.data.roomId, response.data.roomCredential);
    return response.data;
};
const getJoinRequest = async requestId => (await api.get(`/api/rooms/join-requests/${requestId}`)).data;
const cancelJoinRequest = async requestId => (await api.post(`/api/rooms/join-requests/${requestId}/cancel`)).data;
const decideJoinRequest = async (roomId, requestId, approve) =>
    (await api.post(`/api/rooms/${roomId}/join-requests/${requestId}/decision`, { approve })).data;

export { getRoomData, joinRoom, autoRejoinRoom, createNewRoom, leaveRoom, playRandom, getJoinRequest, cancelJoinRequest, decideJoinRequest };
